import { useStore } from 'vuex'
import FouDropdownMenu from 'src/components/general/fou-dropdown-menu'
import { onBeforeMount } from 'vue'
import Misc from 'src/utils/helper/misc'

import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS } from '../../../../../../modules/adobe-cja/constants'
import BlurDateFilter from '../date-filter-blur'


export default{
  components:{
    FouDropdownMenu
  },
  props:{
    options: {
      type: Array,
      required: true
    },
    isBlur: {
      type: Boolean,
      default: false
    }
  },
  setup(props){
    const store = useStore()

    const selectedDateRangeDays =''

    const updateDateRangeDays = (dateRangeDays) => store.dispatch('dashboard/updateDateRangeDays', dateRangeDays)

    const onDatePickerChange = (option) => {
      // dateDropdown.value = option
      const startDate = Misc.formatDate(new Date(option.startDate), 'en', 'YYYY-MM-DD')
      const endDate = Misc.formatDate(new Date(option.endDate), 'en', 'YYYY-MM-DD')
      store.commit('dashboard/setStartDate', startDate)
      store.commit('dashboard/setEndDate', endDate)
      store.dispatch('dashboard/updateDateRangeDays')
      store.commit('salesReport/finalDropdownSelection', option.selected)
      let filterType = '', filterValue = ''
      
      // Determine filter type
      switch (option.selected) {
        case 'this_month':
        case 'last_month':
          filterType = 'Month'
          break
        case 'this_quarter':
        case 'last_quarter':
          filterType = 'Quarter'
          break
        case 'this_year':
        case 'last_year':
          filterType = 'Year'
          break
        default:
          filterType = ''
      }

      // Determine filter value
      switch (option.selected) {
        case 'this_month':
          filterValue = 'This Month'
          break
        case 'last_month':
          filterValue = 'Last Month'
          break
        case 'this_quarter':
          filterValue = 'This Quarter'
          break
        case 'last_quarter':
          filterValue = 'Last Quarter'
          break
        case 'this_year':
          filterValue = 'This Year'
          break
        case 'last_year':
          filterValue = 'Last Year'
          break
        default:
          filterValue = ''
      }

      adobeCjaEventEmitter({
        event: CJA_EVENTS.FILTER_APPLIED,
        filter: {
          filterType: filterType,
          filterValue: filterValue
        }
      })
    }

    const onDropdownChange = (selectedOption) => {
      onDatePickerChange(selectedOption);
    }
    onBeforeMount(() => {
      store.commit('salesReport/finalDropdownSelection', '')
    })

    return{
      selectedDateRangeDays,
      updateDateRangeDays,
      onDropdownChange,
      BlurDateFilter,
      onDatePickerChange
    }
  }
}
